import * as React from "react";
import { useCallback } from "react";
import { useErrorBoundary } from "react-error-boundary";
import { Route } from "react-router";
import { Routes, useNavigate } from "react-router-dom";
import { useUpdatePatientStatus } from "api";
import { isNil } from "ramda";
import { styled } from "styled-components";

import { Button, ButtonVariants, NavigateButton } from "affinityUI/elements/button";
import { Card, Container } from "affinityUI/elements/card";
import { StatusView } from "affinityUI/features/statusView";
import { ButtonGroup } from "affinityUI/form/components";
import { Layout } from "affinityUI/structures/layout";
import { WithdrawDeviceView } from "components/views/patientDetails/device/withdrawDevice";

import { usePatient } from "../context";

import deviceWithdrawn from "./assets/withdrawn.svg";
import { PatientInfo } from "./components/patientInfo";

const StatusContainer = styled(Container)`
  border-top: 1px solid ${(props) => props.theme.colours.bordersLight};
`;

export const WithdrawDevice: React.FC = () => {
  const { showBoundary: onError } = useErrorBoundary();
  const navigate = useNavigate();

  const { patient, loading, refetch } = usePatient();

  const patientId = patient?.id;
  const { updatePatientStatus, loading: loadingEnrollment } = useUpdatePatientStatus();

  const handleWithdrawClick = useCallback(async () => {
    if (!isNil(patientId)) {
      try {
        await updatePatientStatus(patientId);
        await refetch();
        navigate(`/patients/${patientId}`);
      } catch (e) {
        onError(e);
      }
    }
  }, [navigate, onError, patientId, updatePatientStatus, refetch]);

  const actions = (
    <ButtonGroup>
      <NavigateButton to={`/patients/${patientId}`} variant={ButtonVariants.SECONDARY}>
        Cancel
      </NavigateButton>
      <Button disabled={loadingEnrollment} onClick={handleWithdrawClick} variant={ButtonVariants.PRIMARY}>
        {loadingEnrollment ? "Sending request" : "Withdraw Device"}
      </Button>
    </ButtonGroup>
  );
  return (
    <Layout
      title={!isNil(patient) ? `Withdraw device from ${patient?.firstName} ${patient?.lastName}` : "Withdraw device"}
      showBackBtn
      backLink=".."
      loading={loading}
    >
      <Card>
        {!isNil(patient) ? <PatientInfo patient={patient} /> : null}
        <Routes>
          <Route
            index
            element={
              <WithdrawDeviceView actions={<NavigateButton to="confirm">Continue to Confirmation</NavigateButton>} />
            }
          />
          <Route
            path="/confirm"
            element={
              <StatusContainer>
                <StatusView imgSrc={deviceWithdrawn} heading="Please confirm" actions={actions}>
                  Are you sure you want the device to be collected from the patient?
                </StatusView>
              </StatusContainer>
            }
          />
        </Routes>
      </Card>
    </Layout>
  );
};
